export const elementenMixin = {
    data() {
        return {
          inventarisatie: {},
          elementen: {},
          isBusy: false,
        };
      },
      mounted() {
        //this.loadInventarisatie();
      },
      computed: {
        inventariatieUrl: function() {
          return "/unit/" + this.$route.params.id + "/inventarisatie";
        },
      },
      methods: {
        getEigenschapIndex(code) {
          for (var e in this.inventarisatie) {
            var c = code ? code.toUpperCase() : '';
            if (this.inventarisatie[e].Code == c) return e;
          }
        },
        loadElementen() {
            console.log("elementen...");
          var vm = this;
          this.$http
            .get("/elementen")
            .then(function(response) {
              console.dir(response.data);
              vm.elementen = response.data.elementen;
            })
            .catch(function(error) {
              console.log(error);
            });
        },
        loadInventarisatie() {
         console.log("inventarisatie...");
         console.log(this.inventariatieUrl);
          var vm = this;
          this.$http
            .get(this.inventariatieUrl)
            .then(function(response) {
              console.dir(response.data);
              vm.inventarisatie = response.data.inventarisatie;
            })
            .catch(function(error) {
              console.log(error);
            });
        },
        opslaanInventarisatie(inventarisatie) {
          var vm = this;
          vm.boodschap = "Bezig...";
          console.log("opslaan inventarisatie");
          this.isBusy = true;
          this.$http
            .post(
              "/unit/" + this.$route.params.id + "/inventarisatie/",
              { inventarisatie: inventarisatie },
            )
            .then(function(result) {
              vm.boodschap = result.data.resultaat;
              vm.isBusy = false;
            })
            .catch(function(error) {
              vm.boodschap = "Error!";
            })
            .then(function() {
              vm.isBusy = false;
            });
        }
      },
      props: {
        unit: { type: Object },
      }

}